import React,{useState,useRef} from 'react'
import syllabus from "./assets/aesyllabus.pdf"
// import {Link, BrowserRouter, Route, Routes} from "react-router-dom";
// import Ob from './cse4sub/Ob.js';
import Dept from './Dept';
// import AE from './AE';
import aeimg from "./aeimg.jpg"
export default function AE() {
  
  const [sem, setSem] = useState([{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
    ,{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}]);


    const ref = useRef(null);

    const handleClick = () => {
      ref.current.scrollIntoView({behavior: 'smooth'});
    };
  function contentOfElectivePapers(){
    let paper=[
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},
       {sub: 'Elective Courses'},{sub:'List of Professional Elective Courses:'},
        {sub:'Watershed Planning and Management'},{sub:'Environmental Engineering Fundamentals'},
        {sub:'Environmental Microbiological Principle' },
        {sub:'Food Chemistry and MicrobiologyRefrigeration'},
       {sub: 'Air Conditioning Tea Technology'}, {sub:'Dairy Food Technology'},
        {sub:'Testing & Evaluation of Tractors & Machines'},{sub:'Advanced Farm Power'},
        {sub:'Instrumentation and ControlEarth Moving'},
        {sub:'Machinery Ergonomics and Safety'},
        {sub:'Hydraulic Drives and Controls'},{sub:'Aquacultural Engineering'},
        {sub:'Agricultural Business Management'},{sub:'Building Materials & Structural Design'},
        {sub:'Statistical Methods in Agriculture'},
        {sub:'Open Elective Courses:'},
        {sub:'Soft Skills and Interpersonal Communication ICT for Development Human Resource'},
        {sub:'Development and Organizational Behavior'},
        {sub:'Cyber Law and Ethics'},{sub:'Introduction to Philosophical Thoughts'},
        {sub:'Comparative Study of Literature'},{sub:'Indian Music System'},
        {sub:'History of Science & Engineering'},
        {sub:'Introduction to Art and Aesthetics'},{sub:'Economic Policies in India'},//37
    ];
    setSem(paper);
  }
  function contentOfSem1(){
    let content=[
      {title: "Subjects:",sub:"Engineering Physics(ASH101)", link:"/CSE/Ep"},
      {sub:"Mathematics-1(ASH102)", link:"CSE/M_1"},
      {sub:"Engineering Graphics & Design(ASH103)", link:"CSE/Egd"},
      {sub:"Preparatory Engilish(ASH105)", link:"CSE/Peng"},
      {sub:"Engineering Physics Lab(ASH106)", link:"CSE/EpLab"},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
      
    ];
    setSem(content);
  }
  function contentOfSem2(){
    let content=[
      {title: "Subjects:",sub:"Engineering Chemistry(ASH201)", link:"/CSE/Ec"},
      {sub:"Mathematics-2(ASH202)", link:"CSE/M_2"},
      {sub:"Programming for problem Solving(ASH203)", link:"CSE/Pfps"},
      {sub:"Basic Electrical Engineering(ASH204)", link:"CSE/Bee"},
      {sub:"English-2(ASH205)", link:"CSE/Eng_2"},
      {sub:"Engineering Chemistry Lab(ASH206)", link:"CSE/EcLab"},
      {sub:"Programming for Problem Solving Lab(ASH207)", link:"CSE/CLab"}
      ,{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
    setSem(content);
  }
  function contentOfSem3(){
    let content=[
      {title: "Subjects:",sub:"Mathematics-3(ASH301)", link:"/AE/Ma_3"},
      {sub:"Basic Electronics Engineering(ASH302)", link:"AE/Beea"},
      {sub:"Engineering Mechanics(ASH303)", link:"AE/Em"},
      {sub:"Effective Technical Communication(ASH304)", link:"CSE/Etc"},
      {sub:"Fluid Mechanics(AE301)", link:"AE/Fm"},
      {sub:"Thermodynamics(AE302)", link:"AE/Td"},
      {sub:"Fluid Mechanics Lab(AE303)", link:"AE/FmLab"},
      {sub:"Advance Workshop Technology(AE304)", link:"AE/Awi"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
    setSem(content);
  }
  function contentOfSem4(){
    let content=[
       {title: "Subjects:",sub: "Organizational Behavior(ASH401)",link: "/CSE/Ob"},
       {sub: "Strength of Materials(AE401)", link:"AE/Sm"},
       {sub:"Surveying & Leveling(AE402)", link:"AE/Sl"},
       {sub:"Soil Science & Soil Mechanics(AE403)", link:"/AE/Ssm"},
       {sub:"Farm Power(AE404)",link:"AE/Fp"},
       {sub:"Post Harvest Operations(AE405)", link:"AE/Pho"},
       {sub:"Surveying & Leveling Lab(AE406)", link:"/AE/SlLab"},
       {sub:"Soil Science & Soil Mechanics Lab(AE407)", link:"/AE/SsmLab"},
       {sub:"Farm Power Lab(AE408)", link:"AE/FpLab"},
       {sub:"Post Harvest Operations Lab(AE409)",link:"AE/Pho"},
       {sub:"Environmental Science(MC-1)", link:" CSE/Evs" },
        {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
       setSem(content);
  }
  function contentOfSem5(){
    let content=[
      {title: "Subjects:",sub:"Operations Research & Industrial Management(ASH501)", link:"/AE/ORim"},
      {sub:"Kinematics & Theory of Machines(AE501)", link:"AE/Ktm"},
      {sub:"Watershed Hydrology(AE502)", link:"AE/Wh"},
      {sub:"Farm Machinery(AE403)", link:"AE/Fmy"},
      {sub:"Mechanical Operatin in Food Processing(AE404)", link:"AE/Mofp"},
      {sub:"Renewable Energy Technology(AE405)", link:"AE/Ret"},
      {sub:"Watershed Hydrology Lab(AE506)", link:"AE/WhLab"},
      {sub:"Farm Machinery Lab(AE407)", link:"AE/FmyLab"},
      {sub:"Mechanical Operation in Food Processing Lab(AE408)", link:"AE/Mofp"},
      {sub:"Renewable Energy Technology Lab(AE409)", link:"AE/Ret"},
      {sub:"Constitution of India(MC-2)", link:"CSE/Coi"},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
    setSem(content);
  }
  function contentOfSem6(){
    let content=[
      {title: "Subjects:",sub:"Thermal Operation in Food Processing(AE601)", link:"/AE/Tofp"},
      {sub:"Machine Design & Drawing(AE602)", link:"AE/Mdd"},
      {sub:"Soil & Water Conservation Energy(AE603) ", link:"AE/Swce"},
      {sub:"Irrigatin & Drainage Engineering(AE604) ", link:"AE/Ide"},
      {sub:"Thermal Operation in Food Processing Lab(AE605) ", link:"AE/TofpLab"},
      {sub:"Machine Design & Drawing Lab(AE606) ", link:"AE/MddLab"},
      {sub:"Soil & Water Conservation Energy Lab(AE607) ", link:"AE/SwceLab"},
      {sub:"Irrigatin & Drainage Engineering Lab(AE608) ", link:"AE/IdeLab"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
    setSem(content);
  }
  function contentOfSem7(){
    let content=[
      {title: "Subjects:",sub:"Land & Water Resource Management(AE701)", link:"/AE/Lwrm"},
      {sub:"Fruits & Vegetable Processing(AE702)", link:"AE/Fvp"},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},{sub:"", link:""},
      {sub:"Remaining are elective Papers"},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},
      {sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""},{sub:""}
    ];
    setSem(content);
  }
    return (
      <>
          <Dept title="Dept. of Agricultural Engineering" dept="AE" syllabus={syllabus} img={aeimg} /> 
      <div className='container my-3'>
            <h5 className='text-center'>Select your semester to see the corresponding content:</h5>
             <div className="btn-toolbar justify-content-center" role="toolbar" aria-label="Toolbar with button groups">
                <div className="btn-group btn-group-sm" role="group" aria-label="Small group">
               
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem1();handleClick();}}>1st</button>
                  <button type="button" className="btn btn-secondary"onClick={()=>{contentOfSem2();handleClick();}}>2nd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem3();handleClick();}}>3rd</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem4();handleClick();}}>4th</button>
                
                  <button type="button" className="btn btn-secondary"onClick={()=>{contentOfSem5();handleClick();}}>5th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem6();handleClick();}}>6th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfSem7();handleClick();}}>7th</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{alert("Only Project and Elective Papers are in this semester")}}>8th sem</button>
                  <button type="button" className="btn btn-secondary" onClick={()=>{contentOfElectivePapers();handleClick();}}>Elective Papers</button>
                </div>
             </div>
      </div>
         <div className='container my-4 ' ref={ref}>
         <h2 className='mx-5'>{sem[0].title}</h2>       
           <h5 className='mx-5'>
            <div className='my-2'> <a href={sem[0].link}>{sem[0].sub}</a></div>
            <div className='my-2'> <a href={sem[1].link}>{sem[1].sub}</a></div>
            <div className='my-2'><a href={sem[2].link}>{sem[2].sub}</a></div>
            <div className='my-2'><a href={sem[3].link}>{sem[3].sub}</a></div>
            <div className='my-2'><a href={sem[4].link}>{sem[4].sub}</a></div> 
            <div className='my-2'><a href={sem[5].link}>{sem[5].sub}</a></div>
            <div className='my-2'><a href={sem[6].link}>{sem[6].sub}</a></div>
            <div className='my-2'><a href={sem[7].link}>{sem[7].sub}</a></div>
            <div className='my-2'> <a href={sem[8].link}>{sem[8].sub}</a></div>
            <div className='my-2'> <a href={sem[9].link}>{sem[9].sub}</a></div>
            <div className='my-2'> <a href={sem[10].link}>{sem[10].sub}</a></div>
           </h5>
           <h3 className='mx-5'>{sem[11].sub}</h3>
           <h4 className='mx-5'>{sem[12].sub}</h4>
           <h5  className='mx-5'>
           <div>{sem[12].sub}</div>
            <div>{sem[13].sub}</div> <div>{sem[14].sub}</div> <div>{sem[15].sub}</div> <div>{sem[16].sub}</div>
            <div>{sem[17].sub}</div> <div>{sem[18].sub}</div> <div>{sem[19].sub}</div> <div>{sem[20].sub}</div>
            <div>{sem[21].sub}</div> <div>{sem[22].sub}</div> <div>{sem[23].sub}</div> <div>{sem[24].sub}</div>
            <div>{sem[25].sub}</div> <div>{sem[26].sub}</div> <div>{sem[27].sub}</div> <div><h4>{sem[28].sub}</h4></div>
            <div>{sem[29].sub}</div> <div>{sem[30].sub}</div> <div>{sem[31].sub}</div> <div>{sem[32].sub}</div>
            <div>{sem[33].sub}</div> <div>{sem[34].sub}</div> <div>{sem[35].sub}</div> <div>{sem[36].sub}</div>
           
           </h5>
         </div>
      
    </>
  );
}

